import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemReturnFormLinkModal } from '@/types/modal';
import { useGetItemReturnFormLink } from '@/hooks/item';
import { ErrorModal, LoadingModal, CopyModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemReturnFormLinkModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const detailR = useGetItemReturnFormLink(Number(item.productId));

  if (detailR.kind === 'Called') {
    return (
      <LoadingModal
        title={t('oms_return_status.return_form_link.title')}
        onClose={onClose}
      />
    );
  }

  if (detailR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('oms_return_status.return_form_link.title')}
        error={detailR.error}
        onClose={onClose}
      />
    );
  }

  const data = detailR.data;
  const link = data.link ?? '';

  return (
    <CopyModal
      title={t('oms_return_status.return_form_link.title')}
      afterInfo={<br />}
      beforeInfo={
        <>
          <div className={styles.containerGap}>
            <div className={styles.text1rem}>{`${t('common.item')} #${item.productId}`}</div>
            <div className={styles.text1rem}>{t('oms_return_status.return_form_link.description')}</div>
            <div className={styles.text1rem}>{t('oms_return_status.return_form_link.link')}</div>
          </div>
        </>
      }
      textToCopy={link}
      onClose={onClose}
      containerStyle={{ width: 650 }}
    />
  );
};

export default View;
